import type { AlertProps } from "@chakra-ui/react";
import { BannerAlert, Text } from "@equidefi/ui";
import { usePlatformSettings } from "../hooks/usePlatformSettings";
import { formatSystemDownTimestamp } from "./SystemDownBanner.helpers";

export const SystemDownBanner = (props: AlertProps) => {
  const { data: settings } = usePlatformSettings();

  if (!settings?.system_down_enabled) return null;
  if (!settings.system_down_message) return null;

  const formattedTimestamp = formatSystemDownTimestamp(settings.system_down_timestamp);

  return (
    <BannerAlert
      status="warning"
      hideIcon
      my={4}
      data-testid="system-down-banner"
      description={
        <>
          <Text textStyle="body2" whiteSpace="pre-wrap" mb={formattedTimestamp ? 4 : 0}>
            {settings.system_down_message}
          </Text>
          {formattedTimestamp && (
            <Text textStyle="body2" fontWeight="bold" mb={0}>
              {formattedTimestamp}
            </Text>
          )}
        </>
      }
      {...props}
    />
  );
};
